export default __webpack_public_path__ + "static/media/rails.66459aa5.svg";